import { lazy, Suspense } from "react";
import PromoMarquee from "./components/PromoMarquee";
import Navegacion from "./components/Navegacion";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import WhatsAppButton from "./components/WhatsAppButton";
import SEO from "./components/SEO";
import useMetaScrollDepth from "./hooks/useMetaScrollDepth";
import { CookieConsentProvider } from "./context/CookieConsentContext";
import CookieBanner from "./components/CookieBanner";
import CookieSettingsModal from "./components/CookieSettingsModal";

const ProjectGallery = lazy(() =>
  import("./components/ProjectGallery/ProjectGallery")
);

const HomeShowcaseSection = lazy(() =>
  import("./components/HomeShowcaseSection")
);

const ResultsSection = lazy(() =>
  import("./components/ResultsSection")
);

const FinalSection = lazy(() =>
  import("./components/FinalSection")
);

function App() {
  useMetaScrollDepth();
  return (
    <CookieConsentProvider metaPixelId={process.env.REACT_APP_META_PIXEL_ID}>
      <HelmetProvider>
        <>
          <SEO
            title="Inicio"
            description="Agencia creativa especializada en branding, ilustración, animación , botargas, registro de marca y diseño gráfico."
          />

          <div className="App">
            <PromoMarquee />
            <Navegacion whereIam="home" />
            <HeroSection />

            <Suspense fallback={null}>
              <ProjectGallery />
            </Suspense>
            
            <Suspense fallback={null}>
              <HomeShowcaseSection />
            </Suspense>
            
            <Suspense fallback={null}>
              <ResultsSection />
            </Suspense>
            
            <Suspense fallback={null}>
              <FinalSection />
            </Suspense>
            
            <WhatsAppButton />
            <Footer />
          </div>
        </>
      </HelmetProvider>
    <CookieBanner />
    <CookieSettingsModal />
    </CookieConsentProvider>
  );
}

export default App;
